import { jsx } from 'panel';
import { hasSlot } from 'common/util/dom';
import { hasNewQBUI } from '../query-builder/util';
import { AddEntryRow } from './components/add-row';
import { RowLabelType } from './types';
/**
 * Function component to render a variable row template for any given entry row
 */

const EntryRendererFactory = function EntryRendererFactory(_ref) {
  let {
    entry,
    el
  } = _ref;
  const rowProps = {
    section: el,
    index: entry.index,
    entry: entry.entry
  };
  return entry.template.call(entry, rowProps);
};

export function template() {
  const hasNewUI = hasNewQBUI();
  const displayFooter = hasSlot(this, "footer-items") || this.helpers.canAddRow() && !this.attr("disable-add-entry");
  const showLabels = this.attr("row-label-type") !== RowLabelType.None && this.attr("row-limit") !== 1;
  const canAddRow = this.helpers.canAddRow() && !this.attr("disable-add-entry");
  return jsx("div", {
    sel: '.mp-query-entry-section',
    class: {
      'has-labels': showLabels,
      'is-empty': this.helpers.getEntries().length === 0,
      'is-draggable': this.attr("row-draggable"),
      'for-new-metrics-mode': true,
      'for-new-ui': hasNewUI
    }
  }, hasNewUI && (hasSlot(this, "header-items") || this.attr("section-title")) && jsx("div", {
    sel: '.mp-query-entry-section-header'
  }, jsx("div", {
    sel: '.mp-query-entry-section-header-title'
  }, this.attr("section-title")), jsx("slot", {
    attrs: {
      name: "header-items"
    }
  })), this.getRows(true).map(entry => jsx(EntryRendererFactory, {
    entry: entry,
    el: this
  })), displayFooter && jsx("div", {
    sel: '.mp-query-entry-section-footer'
  }, canAddRow && jsx("div", {
    sel: '.mp-query-add-entry-row'
  }, jsx(AddEntryRow, {
    el: this
  })), jsx("slot", {
    attrs: {
      name: "footer-items"
    }
  })));
}